module.exports = __webpack_public_path__ + "img/myles_gaskin.33a048c3.png";